export default __webpack_public_path__ + "static/media/the-villa7.64db05fb.webp";